import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Button } from '@mui/material';
import ORBApi from '../../../Services/ORBApi';
import Loading from '../../../components/common/Loading';

const DeleteTemplateModal = (props) => {
  const [deleting, setDeleting] = useState(false);

  const deleteTemplate = (id) => {
    setDeleting(true);
    ORBApi.deleteContractType(id)
      .then(() => {
        toast.success('Excluido com sucesso!');
      })
      .catch((error) => {
        errorHandler(error);
      })
      .finally(() => {
        setDeleting(false);
        props.setVisible(false);
        props.loadData(1);
      });
  };

  const errorHandler = (error) => {
    console.log(error.response);
    switch (error.response.data.error) {
      case 'CONTRACT_TYPE_BEING_USED':
        toast.warn('O tipo de contrato está em uso!');
        break;
      case 'INVALID_CONTRACT_TYPE_ID':
        toast.warn('Tipo de contrato inválido');
      default:
        toast.warn('Erro ao deletar tipo de contrato');
    }
  };

  return (
    <>
      <h3 style={{ textAlign: 'center' }}>
        Deseja deletar este tipo de contrato ?
      </h3>
      <div
        style={{ display: 'flex', margin: '0 auto', justifyContent: 'center' }}
      >
        {deleting ? (
          <Loading />
        ) : (
          <>
            <Button
              style={{
                marginTop: '15px',
                backgroundColor: 'rgb(245, 0, 87)',
                marginRight: '10px',
              }}
              variant="contained"
              size="large"
              onClick={() => {
                deleteTemplate(props.contractTypeId);
              }}
            >
              {' '}
              Sim, deletar{' '}
            </Button>
            <Button
              style={{ marginTop: '15px', backgroundColor: '#d3d3d3' }}
              variant="contained"
              size="large"
              onClick={() => {
                props.setVisible(false);
              }}
            >
              {' '}
              Não, cancelar{' '}
            </Button>
          </>
        )}
      </div>
    </>
  );
};

export default DeleteTemplateModal;
